import { addDays, addWeeks, addMonths, addYears, differenceInCalendarDays, format, parseISO, isValid } from 'date-fns';
import type { RepeatUnit } from '@/types';

export function computeNextDueDate(currentDue: Date, repeatEvery: number, repeatUnit: RepeatUnit): Date {
  switch (repeatUnit) {
    case 'days':   return addDays(currentDue, repeatEvery);
    case 'weeks':  return addWeeks(currentDue, repeatEvery);
    case 'months': return addMonths(currentDue, repeatEvery);
    case 'years':  return addYears(currentDue, repeatEvery);
  }
}

export function daysUntil(dateStr: string): number {
  const d = parseISO(dateStr);
  return differenceInCalendarDays(d, new Date());
}

export function formatDate(dateStr: string | null | undefined): string {
  if (!dateStr) return '—';
  const d = parseISO(dateStr);
  if (!isValid(d)) return '—';
  return format(d, 'dd MMM yyyy');
}

export function toISODate(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}

export function urgencyClass(daysUntilDue: number): string {
  if (daysUntilDue < 0)   return 'text-red-600 bg-red-50 border-red-200';
  if (daysUntilDue <= 7)  return 'text-amber-600 bg-amber-50 border-amber-200';
  return 'text-emerald-600 bg-emerald-50 border-emerald-200';
}

export function urgencyDot(daysUntilDue: number): string {
  if (daysUntilDue < 0)  return 'bg-red-500';
  if (daysUntilDue <= 7) return 'bg-amber-500';
  return 'bg-emerald-500';
}

export function urgencyLabel(daysUntilDue: number): string {
  if (daysUntilDue < 0)   return `${Math.abs(daysUntilDue)}d overdue`;
  if (daysUntilDue === 0) return 'Due today';
  if (daysUntilDue === 1) return 'Due tomorrow';
  return `In ${daysUntilDue} days`;
}
